<template>
  <Authenticated>
    <Confirm
      :open="showDeleteConfirm"
      :isDeleteConfirm="true"
      message="Are you sure you want to delete this category?"
      subMsg="By deleting this category you will delete all associated products. This can not be undone"
      @confirmModal="removeCategory"
      @close="confirmDelete" />
    <ProductModal
      :open="productModalShow"
      :product="currentProduct"
      :modifierSets="modifier_sets"
      @closeModal="closeModal"
      @save="saveProduct"
      @remove="removeProduct"
      @clone="cloneProduct" />
    <div v-if="current">
      <div class="action-buttons">
        <button class="action-colour" @click="showProduct"><font-awesome-icon icon="plus" /> <span v-if="!portrait">Add Product</span></button>
        <button class="danger" @click="confirmDelete"><font-awesome-icon icon="trash" /> <span v-if="!portrait">Delete Category</span></button>
      </div>
      <div class="actions">
        <font-awesome-icon class="backwards" icon="backward" @click.stop.prevent="$router.go(-1)"></font-awesome-icon>

        <h2 class="title">{{ name }}</h2>
      </div>
      <div class="description">
        <div class="preview">
          <h3>Description:</h3>
          <div class="layout">
            <p class="desc" v-html="current.description"></p>
            <font-awesome-icon icon="pencil" :class="editorShow ? 'icon-active' : 'icon'" @click="this.editorShow = !this.editorShow" />
          </div>
        </div>
        <div :className="editorShow ? 'editor-show' : 'editor-hide'" id="center">
          <textarea type="text" rows="6" class="radius" v-model="current.description"></textarea>
          <button class="action primary action-colour" @click.prevent.stop="save">Save</button>
        </div>
      </div>
      <div class="toggles">
        <ToggleSwitch onLabel="POS Only" offLabel="POS/WEB" :modelValue="current.posOnly" modelName="posOnly" @update:modelValue="updatePosOnly" />
        <ToggleSwitch onLabel="Edit" offLabel="Re Order" :modelValue="reOrder" modelName="reOrder" @update:modelValue="updateReOrder" />
      </div>
      <draggable v-if="reOrder" :list="products" @start="drag = true" @end="checkMove" tag="ul" class="grid wrapper content-gap" item-key="element">
        <template #item="{ element }">
          <li class="modifierBox">
            <div class="box">
              <p style="text-align: center">
                <span class="modifier-name">{{ getProduct(element).name }}</span>
                <span class="modifier-price"><CurrencyFormatter :value="getProduct(element) ? (+getProduct(element).price) : '0.00'" :currency="currency" /></span>
              </p>
            </div>
          </li>
        </template>
      </draggable>
      <ul v-if="!reOrder" :class="(tableMode ? 'table' : 'grid') + ' wrapper content-gap'">
        <!-- <router-link :to="'/products/' + $route.params.category + '/' + product" replace  class="modifierBox" > -->
        <li v-bind:key="idx" v-for="(product, idx) in products" class="modifierBox" @click.stop.prevent="showProduct(product)">
          <div class="box" v-if="getProduct(product)">
            <p style="text-align: center">
              <span class="modifier-name">{{ getProduct(product).name }}</span>
              <span class="modifier-price"><CurrencyFormatter :value="getProduct(product) ? (+getProduct(product).price) : '0.00'" :currency="currency" /></span>
            </p>
          </div>
        </li>
        <!-- </router-link> -->
      </ul>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { Confirm, ProductModal, ToggleSwitch, CurrencyFormatter } from "@monolith/components";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import Slug from "slug";

export default {
  name: "Category",
  components: {
    Authenticated,
    Confirm,
    ToggleSwitch,
    ProductModal,
    draggable,
    CurrencyFormatter,
  },

  data() {
    return {
      currentProduct: null,
      currentDrag: null,
      currentDragOverCategory: null,
      showDeleteConfirm: false,
      inventory: false,
      required: false,
      oneonly: false,
      loaded: false,
      showProductModal: false,
      tableMode: false,
      editorShow: false,
      drag: false,
      reOrder: false,
      productRoute: false,
      posOnly: false,
      portrait: false,
      openProduct: false,
    };
  },

  methods: {
    closeModal() {
      this.showProductModal = false;
      this.$router.go(-1);
    },
    checkMove: function () {
      this.drag = false;
      //this.products.splice(e.draggedContext.index, 1);
      //this.products.splice(e.draggedContext.futureIndex, 0, e.draggedContext.element);
      this.channel.push("document:update", this.current);
    },
    reOrderProducts() {
      this.reOrder = !this.reOrder;
    },
    confirmDelete() {
      this.showDeleteConfirm = !this.showDeleteConfirm;
    },
    save() {
      this.channel.push("document:update", this.current);
    },
    updatePosOnly(value) {
      this.current.posOnly = value;
      this.save();
    },
    updateReOrder(value) {
      this.reOrder = value;
    },
    newItem() {
      this.channel.push("document:new", this.current);
    },
    getProduct(name) {
      var foundProduct = this.allProducts.find((p) => {
        return p.id === "product:" + name;
      });
      return foundProduct ? foundProduct.value : null;
    },
    updateProduct(name) {
      this.currentProduct = this.getProduct(name);
    },
    getBackground(name) {
      var foundProduct = this.allProducts.find((p) => {
        return p.id === "product:" + name;
      });
      return foundProduct && foundProduct.value.image ? "color: var(--primary-colour); background-size: contains; background-image: url(" + foundProduct.value.image + ");" : "";
    },

    async showProduct(product_slug) {
      var foundProduct = await this.allProducts.find((p) => {
        return p.id === "product:" + product_slug;
      });
      if (foundProduct) {
        this.$router.push(`/products/${this.slug}/${product_slug}`);
        if (!foundProduct.value.soldout) {
          foundProduct.value.soldout = false;
        }
        this.currentProduct = foundProduct.value;
      } else {
        this.$router.push(`/products/${this.slug}/new-entry`);
        this.currentProduct = {
          name: null,
          description: null,
          caption: null,
          active: true,
          price: null,
          modifiersets: [],
          images: [],
          soldout: false,
        };
      }
      this.showProductModal = true;
    },
    cloneProduct(product) {
      this.currentProduct = product;
      this.currentProduct._id = null;
      this.currentProduct._rev = null;
      this.currentProduct.name = null;
      this.showProductModal = !this.showProductModal;
    },
    saveProduct(product) {
      var foundProduct = this.allProducts.find((p) => {
        return p.id === "product:" + Slug(product.name);
      });
      if (foundProduct) {
        foundProduct = product;
        this.channel.push("document:update", product);
      } else {
        product._id = "product:" + Slug(product.name);
        product.category = Slug(this.name);
        this.channel.push("document:new", product);
        this.current.products.push(Slug(product.name));
        this.save();
        // this.$store.dispatch("getProducts");
      }
      this.$notify({
        title: "Product has been saved",
        type: "success",
      });
    },
    async removeProduct(product) {
      var foundProductIndex = this.current.products.findIndex((p) => {
        return "product:" + p === product._id;
      });

      if (foundProductIndex != -1) {
        await this.channel.push("document:delete", {
          doc: product._id,
          rev: product._rev,
          category: Slug(this.name),
        });
        this.current.products.splice(foundProductIndex, 1);
        this.save();
        this.$store.dispatch("getProducts");
      }
    },
    async removeCategory() {
      /* step two remove it from modifier_sets */
      await this.channel.push("document:delete", {
        doc: this.current._id,
        rev: this.current._rev,
      });
      this.$router.push("/products");
    },

    handleOrientationChange() {
      this.portrait = window.matchMedia("(orientation: portrait)").matches;
    },
  },

  watch: {
    "current.active": {
      handler: function (newValue, oldValue) {
        if (oldValue != null) this.save();
      },
    },
    posOnly: {
      handler: function () {
        this.current.posOnly = this.posOnly;
        this.save();
      },
    },
    allProducts: {
      handler: function () {
        if (this.$route.params.product) {
          this.showProduct(this.$route.params.product);
        }
      },
    },
  },

  mounted() {
    this.$store.commit("currPage", "products");
    this.portrait = window.matchMedia("(orientation: portrait)").matches;

    const mediaQuery = window.matchMedia("(orientation: portrait)");
    mediaQuery.addEventListener("change", this.handleOrientationChange);
  },

  computed: {
    productModalShow() {
      if (this.productRoute) {
        if (this.getProduct(this.$route.params.product)) {
          this.updateProduct(this.$route.params.product);
          return true;
        } else {
          return this.showProductModal;
        }
      } else {
        return this.showProductModal;
      }
    },
    product() {
      this.getProduct("test");
      return "test";
    },
    slug() {
      return this.$route.params.category;
    },
    fullslug() {
      return "category:" + this.$route.params.category;
    },
    name() {
      return this.$route.params.category.replace(/-/g, " ");
    },
    current() {
      let foundCategory = this.categories.find((category) => category.id === "category:" + this.slug);
      return foundCategory ? foundCategory.value : null;
    },
    products() {
      return this.current ? this.current.products : null;
    },
    ...mapGetters({
      categories: "allCategories",
      modifier_sets: "modifier_sets",
      allProducts: "allProducts",
      socketConnected: "socketConnected",
      currency: "currency",
    }),
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.radius {
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
  width: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.description {
  padding-top: 0;
}

.action-buttons {
  position: fixed;
}

.toggles {
  display: flex;
  margin: 1rem 0;
  width: 100%;
}

@media screen and (orientation: portrait) {
  .outer-container {
    max-height: 100vh;
    max-width: 100vw;
    .action-buttons {
      display: flex;
      align-items: flex-end;
      position: fixed;
      flex-direction: column;
      .add-remove {
        order: 1;
        flex: 1 0 100%;
      }
      button {
        min-width: 5rem;
        margin: 0.5rem !important;
      }
    }

    .description {
      padding: 0;
      width: 100%;
      .editor-show {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        padding: 0 !important;
        justify-content: center;
        align-items: center;
        .radius {
          min-width: 80% !important;
        }
      }
    }

    .toggles {
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
